export const Autho0Config = {
  domain: 'auth.periwinklefox.com',
  clientId: 'NG1F2mWtnR74SJ6wa4KFx8WXxnj5ViJq',
  audience: 'http://api.periwinklefox.com'  
}
